import React, { FC } from 'react';
import { Text } from 'components/text/Text';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Card } from 'antd/es';
import { SingleStatistic } from 'src/pages-all/tutoring-institute/components/stats/SingleStatistic';
import { EYE, HOME, SEARCH, STAR } from 'assets/icons/tutoring-institute';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getTutoringInstituteOverallStats } from 'logic/store/authentication/authentication.selectors';
import { OffersListResponse } from 'logic/api-models/api-models';
import { roundToXDecimals } from 'logic/utils/number';

const StatsHead = styled.div`
  margin-top: 12px;
  margin-bottom: 25px;
`;

const StatsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 240px;
`;

type Props = {
  instituteOffers?: OffersListResponse;
};

export const AllStats: FC<Props> = ({ instituteOffers }) => {
  const totalOffers = instituteOffers?.totalCount || 0;
  const {
    averageRating = 0,
    totalRatings,
    totalOffersAppearedOnSearch,
    totalOffersDetailsDisplayed,
  } = useSelector(getTutoringInstituteOverallStats);

  return (
    <div>
      <StatsHead>
        <Text fontWeight={500} size={30}>
          {translate(translationKeys.tutoringInstituteProfile.offersPage.statistics)}
        </Text>
      </StatsHead>
      <Card>
        <StatsWrapper>
          <SingleStatistic
            img={HOME}
            value={`${totalOffers}`}
            caption={translate(translationKeys.tutoringInstituteProfile.offersPage.offersOnline)}
          />
          <SingleStatistic
            img={STAR}
            value={`${roundToXDecimals(averageRating)}/5 (${totalRatings})`}
            caption={translate(translationKeys.tutoringInstituteProfile.offersPage.reviews)}
          />
          <SingleStatistic
            img={SEARCH}
            value={`${totalOffersAppearedOnSearch}`}
            caption={translate(
              translationKeys.tutoringInstituteProfile.offersPage.totalOffersAppearedOnSearch
            )}
          />
          <SingleStatistic
            img={EYE}
            value={`${totalOffersDetailsDisplayed}`}
            caption={translate(
              translationKeys.tutoringInstituteProfile.offersPage.totalOffersDetailsDisplayed
            )}
          />
        </StatsWrapper>
      </Card>
    </div>
  );
};
